<template>
  <div class="standard-page">
    <div class="detail-view-header">
      Merchant Detail
    </div>
    <div class="detail-view-deck">
      <b-card class="detail-view-info-card">
        <b-row>
          <b-col class="merchant-detail-img" cols="3">
            <b-img :src="merchant.logo" />
          </b-col>
          <b-col class="merchant-detail-main-info" cols="9">
            <b-row align-h="end">
              <h4>{{ merchant.name }}</h4>
            </b-row>
            <b-row align-h="end">
              <a :href="merchant.website_url">
                {{ merchant.website_url }}
              </a>
            </b-row>
          </b-col>
        </b-row>
        <LabeledInfo label="Doing Business As" :value="merchant.dba_name" />
        <LabeledInfo label="Description" :value="merchant.description" />
        <LabeledInfo label="Support Email" :value="merchant.support_email" />
      </b-card>
      <b-card class="detail-view-info-card">
        <LabeledInfo label="Address" :value="merchant.address" />
        <LabeledInfo label="Address ln 2" :value="merchant.address2" />
        <LabeledInfo label="City" :value="merchant.city" />
        <LabeledInfo label="Postal Code" :value="merchant.postal_code" />
        <LabeledInfo label="State/Province" :value="merchant.state_province" />
        <LabeledInfo label="Country" :value="merchant.country" />
      </b-card>
      <b-card class="detail-view-info-card">
        <LabeledInfo label="ID" :value="merchant.id" />
        <LabeledInfo label="External ID" :value="merchant.external_id" />
        <LabeledInfo label="EIN" :value="merchant.ein" />
        <LabeledInfo label="Currency Code" :value="merchant.currency_code" />
        <LabeledInfo
          label="Monthly Volume"
          :value="merchant.monthly_volume"
          type="money"
        />
        <LabeledInfo
          label="Max Charge"
          :value="merchant.max_charge"
          type="money"
        />
        <LabeledInfo
          label="Average Charge"
          :value="merchant.average_charge"
          type="money"
        />
        <LabeledInfo
          label="In Legacy App"
          :value="merchant.in_legacy_app"
          type="boolean"
        />
        <LabeledInfo label="Partner" :value="merchant.partner" />
      </b-card>
      <b-card class="detail-view-info-card">
        <LabeledInfo
          label="Ready To Submit"
          :value="merchant.ready_to_submit.ready_to_submit"
          type="boolean"
        />
        <b-row>
          <b-col cols="4">
            <label class="labeled-info-label">Errors:</label>
          </b-col>
          <b-col class="merchant-detail-response-errors" cols="8">
            <div v-for="error in merchant.ready_to_submit.errors" :key="error">
              {{ error }}
            </div>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
import endpoints from '@/utils/endpoints.js'

export default {
  /* TODO handle "merchant_accounts" and "owner_agents"*/
  data() {
    return {
      merchant: {
        ready_to_submit: {}
      }
    }
  },
  mounted() {
    this.getMerchant()
  },
  methods: {
    getMerchant() {
      this.axios
        .get(
          endpoints.retrieveMerchantOrganization(this.$route.params.merchantID)
        )
        .then(res => {
          this.merchant = res.data
        })
        .catch(err => {
          console.log('error', err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.merchant-detail-img,
.merchant-detail-main-info {
  padding: 5px 20px 15px 20px;
}
.merchant-detail-main-info {
  text-align: right;
}
.merchant-detail-response-errors {
  color: $darker-gray;
  text-align: end;
  font-size: 16px;
}
</style>
